import React, {useState} from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import {Home, OddVariations} from './pages';
import {userServices} from './api';
import WebSocketProvider from "./components/websocket/WebSocketProvider";

function App() {

    const searchParams = new URLSearchParams(window.location.search);

    const [token, setToken] = useState(searchParams.get('token') ?? localStorage.getItem('token'));

    React.useEffect(() => {
        if (token !== null) {
            userServices.checkToken(token)
                .then((response) => {
                    localStorage.setItem('token', token);
                    if (response.data.data.bookmaker) {
                        localStorage.setItem("bookmaker", response.data.data.bookmaker);
                    }
                    if (response.data.data.products) {
                        localStorage.setItem("products", JSON.stringify(response.data.data.products));
                    }
                    localStorage.setItem("user", response.data.data.email)
                })
                .catch((err) => {
                    handleLogout()
                })
        }
    }, [token]);


    const handleLogout = () => {
        setToken(null)
        localStorage.removeItem("token");
        localStorage.removeItem("bookmaker")
        localStorage.removeItem("products")
        localStorage.removeItem("user")
    }

    return <WebSocketProvider>
        <Router>
            {token ?
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/:client/oddvariations" element={<OddVariations/>}/>
                    <Route path="*" element={<Navigate to='/'/>}/>
                </Routes>
                :
                <Routes>
                    <Route exact path="*" element={<Home/>}/>
                </Routes>
            }
        </Router>
    </WebSocketProvider>
}

export default App;
